'use client';

import { ArrowRight, Play } from 'lucide-react';
// import { useState } from 'react';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import getYouTubeID from 'get-youtube-id';
import Link from 'next/link';

interface VohTvDataItem {
    id: number;
    embeddedLink: string;
    vohTvType: { type: string };
    contentHeading: string;
    description: string;
}

export default function VOHVideoPage({ vohTvData }: { vohTvData: VohTvDataItem[] }) {
    // console.log(vohTvData)
    // const [isHovered, setIsHovered] = useState(false);
    // const [hoveredItem, setHoveredItem] = useState<number | null>(null);

    return (
        <div className="bg-[#0a1017] text-white py-04">
            <div className="py-8">
                {/* Header */}
                <div className="container mx-auto px-4 py-8 flex justify-between items-center">
                    <h1 
                        className="text-3xl md:text-5xl"
                        style={{ fontFamily: 'Sentient', fontWeight: '700', lineHeight: '52.8px' }}
                    >
                        VOH TV
                    </h1>
                    <Link href={`/allbroadcast`}>
                        <button
                            className="bg-white text-black px-4 md:px-6 py-2 md:py-3 font-medium hover:bg-gray-100 transition-colors rounded-lg"
                            style={{
                                fontFamily: 'Sentient',
                                fontWeight: '500',
                                fontSize: '18px',
                                lineHeight: '28.8px',
                            }}
                        >
                            See All Videos
                        </button>
                    </Link>
                </div>
                {/* Main Content */}
                <div className="container mx-auto px-4 pb-16">
                    <div className="grid md:grid-cols-2 gap-8 items-center">
                        {/* Video Thumbnail */}
                        <div
                            className="relative group cursor-pointer"
                            // onMouseEnter={() => setIsHovered(true)}
                            // onMouseLeave={() => setIsHovered(false)}
                        >
                            <div className="relative">
                                <LiteYouTubeEmbed title="hi" id={getYouTubeID(vohTvData[0].embeddedLink) as any} />
                                {/* <div className="absolute inset-0 bg-black bg-opacity-20 flex items-center justify-center">
                                    <div
                                        className={`w-16 h-16 rounded-full bg-white bg-opacity-80 flex items-center justify-center transition-transform duration-300 ${
                                            isHovered ? 'scale-110' : 'scale-100'
                                        }`}
                                    >
                                        <Play className="w-6 h-6 text-black ml-1" fill="currentColor" />
                                    </div>
                                </div> */}
                            </div>
                        </div>

                        {/* Video Info */}
                        <div className="space-y-4">
                            <div
                                className="inline-block border bg-[#02B6A633] border-white px-4 py-2 text-sm tracking-wider rounded-[10px]"
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: '400',
                                    fontSize: '16px',
                                    lineHeight: '19.2px',
                                    letterSpacing: '1.92px',
                                }}
                            >
                                {vohTvData[0].vohTvType.type}
                            </div>

                            <h2
                                className="leading-tight line-clamp-2"
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: '600',
                                    fontSize: '24px',
                                    lineHeight: '28.8px',
                                    letterSpacing: '0px',
                                }}
                            >
                                {vohTvData[0].contentHeading}
                            </h2>

                            <p
                                className="text-[#D9D9D9] leading-relaxed"
                                style={{
                                    fontFamily: 'Inter',
                                    fontWeight: '400',
                                    fontSize: '16px',
                                    lineHeight: '23px',
                                    letterSpacing: '0px',
                                }}
                            >
                                {vohTvData[0].description}
                            </p>
                            <Link href={vohTvData[0].embeddedLink}>
                                <button className="flex items-center space-x-2 text-[#75C8FF] hover:text-blue-300 transition-colors group mt-4">
                                    <Play className="w-5 h-5 text-white" fill="currentColor" />
                                    <span
                                        style={{
                                            fontFamily: 'Inter',
                                            fontWeight: '500',
                                            fontSize: '20px',
                                            lineHeight: '24px',
                                            letterSpacing: '0px',
                                        }}
                                    >
                                        Watch Now
                                    </span>
                                    <ArrowRight className="w-5 h-5 transform group-hover:translate-x-1 transition-transform duration-300" />
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                {/* Cards */}
                {/* <div className="container mx-auto px-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 divide-x divide-gray-700 mb-12 ">
                        {vohTvData.slice(1, 5).map((item) => (
                            <div
                                key={item.id}
                                className="relative p-4 cursor-pointer"
                                // onMouseEnter={() => setHoveredItem(item.id)}
                                // onMouseLeave={() => setHoveredItem(null)}
                                // onMouseEnter={() => setIsHovered(true)}
                                // onMouseLeave={() => setIsHovered(false)}
                            >
                                <div className="space-y-3">
                                    <div className="overflow-hidden">
                                        <LiteYouTubeEmbed title="hi" id={getYouTubeID(item.embeddedLink) as any} />
                                    </div>
                                    <div
                                        className="inline-block border bg-[#02B6A633] border-white px-4 py-2 text-sm tracking-wider rounded-[10px]"
                                        style={{
                                            fontFamily: 'Inter',
                                            fontWeight: '400',
                                            fontSize: '11.81px',
                                            lineHeight: '14.18px',
                                            letterSpacing: '1.42px',
                                        }}
                                    >
                                        {item.vohTvType.type}
                                    </div>

                                    <h3
                                        className="leading-tight line-clamp-2"
                                        style={{
                                            fontFamily: 'Inter',
                                            fontWeight: '600',
                                            fontSize: '18px',
                                            lineHeight: '21.6px',
                                            letterSpacing: '0px',
                                            lineClamp: 2,
                                        }}
                                    >
                                        {item.contentHeading}
                                    </h3>

                                    <p
                                        className="text-[#C2C2C2] line-clamp-3"
                                        style={{
                                            fontFamily: 'Inter',
                                            fontWeight: '400',
                                            fontSize: '14px',
                                            lineHeight: '18.6px',
                                            letterSpacing: '0px',
                                        }}
                                    >
                                        {item.description}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div> */}
            </div>
            <div className="">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 mb-12 lg:border-t-[1px] lg:border-solid lg:border-[#FFFFFF] lg:px-16">
                    {vohTvData.slice(1, 5).map((item, index) => (
                        <div
                            key={item.id}
                            className={`relative cursor-pointer ${
                                index < 3 ? 'lg:border-r-[1px]' : ''
                            } lg:border-solid lg:border-[#FFFFFF] py-8 lg:py-16 px-12`}
                        >
                            <div className="space-y-3">
                                <div className="overflow-hidden">
                                    <LiteYouTubeEmbed title="hi" id={getYouTubeID(item.embeddedLink) as any} />
                                </div>
                                <div
                                    className="inline-block border bg-[#02B6A633] border-black px-4 py-2 text-sm tracking-wider rounded-[10px]"
                                    style={{
                                        fontFamily: 'Inter',
                                        fontWeight: '400',
                                        fontSize: '11.81px',
                                        lineHeight: '14.18px',
                                        letterSpacing: '1.42px',
                                    }}
                                >
                                    {item.vohTvType.type}
                                </div>

                                <h3
                                    className="leading-tight line-clamp-2"
                                    style={{
                                        fontFamily: 'Inter',
                                        fontWeight: '600',
                                        fontSize: '18px',
                                        lineHeight: '21.6px',
                                        letterSpacing: '0px',
                                        lineClamp: 2,
                                    }}
                                >
                                    {item.contentHeading}
                                </h3>

                                <p
                                    className="text-[#C2C2C2] line-clamp-3"
                                    style={{
                                        fontFamily: 'Inter',
                                        fontWeight: '400',
                                        fontSize: '14px',
                                        lineHeight: '18.6px',
                                        letterSpacing: '0px',
                                    }}
                                >
                                    {item.description}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
